// Hub-specific login page extensions: plan selector, language selector, tab image switching.

export const onTabClick = (targetId) => {
    let $images = $('[data-bind="loginTabImage"]');
    $images.removeClass('active');
    $images.filter(targetId.replace('#', '.')).addClass('active');
};

export const onInit = () => {
    initPlanSelect();
    initLanguageSelect();
};

function initPlanSelect() {
    let $planSelect = $('#plan-select');

    $planSelect.select2({
        minimumResultsForSearch: -1,
        theme: 'default select-element select-element-signup select-gray',
        templateResult: formatState,
        templateSelection: formatState
    }).on('select2:select', formatSelect);

    if ($planSelect.find(':selected').val()) formatSelect();

    function formatSelect() {
        $planSelect.next().find('.select2-selection').css('overflow', 'hidden');
        $planSelect.next().find('.select2-selection__rendered').addClass('p-0').css('font-weight', 'inherit');
    }

    function formatState(state) {
        if (!state.id) return state.text;
        return $(`<div class='${state.element.dataset.bg} ${state.element.dataset.color} p-2 p-md-3'><strong>${state.text}</strong><br>${state.element.dataset.text || ""}</div>`);
    }
}

function initLanguageSelect() {
    $('#language-signup').select2({
        minimumResultsForSearch: -1,
        theme: 'default',
        width: '150px',
    });
}
